// @flow

import { PageTitle } from "@/components/shared/title/page-title";
import TundishTrackSvg from "@/pages/svg/branding/TundishTrackSvg";
import CassopeiaSvg from "@/pages/svg/branding/cassopeia.svg";
import LadleTrackSvg from "@/pages/svg/branding/ladle-track.svg";
import {
	TrackModeContext,
	TrackModeEnum,
} from "@/providers/track-mode.provider";
import { Grid } from "@material-ui/core";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

type Props = {};
export const ChooseModeComponent = (props: Props) => {
	const { setTrackMode } = useContext(TrackModeContext);
	const navigate = useNavigate();

	const choose = (trackMode: TrackModeEnum) => {
		setTrackMode(trackMode);
		if (trackMode === TrackModeEnum.LADLE_TRACK) {
			navigate("/ladle-track/plant-overview");
		}
		if (trackMode === TrackModeEnum.TUNDISH_TRACK) {
			navigate("/tundish-track/plant-overview");
		}
	};

	return (
		<div style={{ paddingTop: "2rem" }}>
			<PageTitle title="Choose Mode" />
			<Grid
				container
				direction="column"
				justifyContent="center"
				alignContent="center"
				spacing={3}
			>
				<Grid item container justifyContent="center" alignContent="center">
					<CassopeiaSvg />
				</Grid>
				<Grid item container justifyContent="center" alignContent="center">
					<LadleTrackSvg
						data-testid="ladle-track-button"
						onClick={() => choose(TrackModeEnum.LADLE_TRACK)}
						style={{ cursor: "pointer" }}
					/>
					<TundishTrackSvg
						data-testid="tundish-track-button"
						onClick={() => choose(TrackModeEnum.TUNDISH_TRACK)}
						style={{ cursor: "pointer" }}
					/>
				</Grid>
			</Grid>
		</div>
	);
};
